define("Bazaarvoice.PDP.Reviews.View", [
  "SCView",
  "bazaarvoice_pdp_reviews.tpl",
  "underscore",
], function (SCViewComponent, bazaarvoice_pdp_reviews_tpl, _) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function BazaarvoicePDPReviewsView(options) {
    SCView.call(this);

    this.options = options || {};
    this.container = this.options.container;
    this.template = bazaarvoice_pdp_reviews_tpl;
    this.pdp = this.container.getComponent("PDP");

    // For matrix selection
    this.pdp.cancelableOn("afterOptionSelection", _.bind(this.render, this));
  }

  BazaarvoicePDPReviewsView.prototype = Object.create(SCView.prototype);

  BazaarvoicePDPReviewsView.prototype.constructor = BazaarvoicePDPReviewsView;

  BazaarvoicePDPReviewsView.prototype.getItem = function () {
    var iteminfo = this.pdp && this.pdp.getItemInfo();

    if (!iteminfo) {
      return {};
    }

    var selectedMatrixChilds = this.pdp.getSelectedMatrixChilds();
    var matrixSelected =
      !!_.size(selectedMatrixChilds) && _.first(selectedMatrixChilds);

    return matrixSelected ? matrixSelected : iteminfo.item || {};
  };

  BazaarvoicePDPReviewsView.prototype.getContext = function () {
    var item = this.getItem();

    return {
      productId: item.itemid,
    };
  };

  return BazaarvoicePDPReviewsView;
});
